import React, {useEffect, useState} from 'react';
import {FormattedMessage, useIntl} from "react-intl";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow
} from "@mui/material";
import CloseButton from "../../../components/buttons/CloseButton";
import {FileApi} from "../../../modules/ftp/api/FileApi";
import DownloadButton from "../../../components/buttons/DownloadButton";
import {RequestVisitorDto} from "../../../modules/vms/dto/RequestVisitorDto";
import {VisitorAttachFileClassify} from "../../../modules/vms/enums/VisitorFileClassify";
import {RequestVisitorAttachFile} from "../../../modules/vms/dto/RequestVisitorAttachFile";

export type VisitorAttachFilesDialogProps = {
    open: boolean;
    requestVisitor: RequestVisitorDto;
    onClose: () => void;
};

const VisitorAttachFilesDialog: React.FC<VisitorAttachFilesDialogProps> = (props) => {
    const intl = useIntl();

    const [files, setFiles] = useState<Array<RequestVisitorAttachFile>>([]);

    useEffect(() => {
        if (props.open && props.requestVisitor.attachFiles) {
            const attachFilesArray = JSON.parse(props.requestVisitor.attachFiles);
            setFiles(attachFilesArray);
        }
    }, [props.open]);

    const handleClose = () => {
        props.onClose();
    };

    const handleDownload = async (id: string, name: string) => {
        await FileApi.downloadFile(id, name);
    };

    return (
        <Dialog open={props.open} onClose={handleClose} fullWidth={true} maxWidth={'md'}>
            <DialogTitle>
                {intl.formatMessage({id: 'VMS_REQUEST_VISITOR_ATTACH_FILE'})}
            </DialogTitle>
            <DialogContent>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>{intl.formatMessage({id: 'VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY'})}</TableCell>
                            <TableCell>{intl.formatMessage({id: 'VMS_REQUEST_VISITOR_ATTACH_FILE_NAME'})}</TableCell>
                            <TableCell>{intl.formatMessage({id: 'COMMON_ACTION'})}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {files.map((row, index) => (
                            <TableRow key={row.fileId}>
                                <TableCell><FormattedMessage
                                    id={VisitorAttachFileClassify.Map.get(row.classify)}/></TableCell>
                                <TableCell>{row.fileName}</TableCell>
                                <TableCell><DownloadButton
                                    onClick={() => handleDownload(row.fileId, row.fileName)}/></TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </DialogContent>
            <DialogActions>
                <CloseButton onClick={handleClose}/>
            </DialogActions>
        </Dialog>
    );
};

export default VisitorAttachFilesDialog;
